"use strict";

var WEDDING_PLANNER_BOXES = 'Wedding Planner Boxes';
var SILK_RIBBON_SAMPLES = 'Silk Ribbon Samples';
var CUSTOM_SAMPLES = 'Custom Samples';
var CLASSIC_WEDDING_INVITATION_SAMPLES = 'Classic Invitation Samples';
var LETTERPRESS_WEDDING_INVITATION_SAMPLES = 'Letterpress Invitation Samples';
module.exports = {
  CUSTOM_SAMPLES: CUSTOM_SAMPLES,
  WEDDING_PLANNER_BOXES: WEDDING_PLANNER_BOXES,
  SILK_RIBBON_SAMPLES: SILK_RIBBON_SAMPLES,
  CLASSIC_WEDDING_INVITATION_SAMPLES: CLASSIC_WEDDING_INVITATION_SAMPLES,
  LETTERPRESS_WEDDING_INVITATION_SAMPLES: LETTERPRESS_WEDDING_INVITATION_SAMPLES
};